import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";

const MyCourses = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("all");

  const [cart, setCart] = useState(() => {
    return JSON.parse(localStorage.getItem("cartItems")) || [];
  });

  const [myCourses, setMyCourses] = useState([
    {
      id: 1,
      title: "Groovy & Grails Masterclass",
      description:
        "Learn to build modern web applications with Groovy and Grails framework from scratch.",
      progress: 65,
      author: "Dr. Sarah Johnson",
      lastAccessed: "2 days ago",
      duration: "8 weeks",
      difficulty: "Intermediate",
      rating: 4.7,
      students: 1245,
      thumbnail:
        "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      category: "Web Development",
      lessonsCompleted: 12,
      totalLessons: 18,
    },
    {
      id: 2,
      title: "Java Programming Bootcamp",
      description:
        "Comprehensive Java course covering fundamentals to advanced topics with hands-on projects.",
      progress: 30,
      author: "Prof. Michael Chen",
      lastAccessed: "1 week ago",
      duration: "10 weeks",
      difficulty: "Beginner",
      rating: 4.9,
      students: 3562,
      thumbnail:
        "https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      category: "Programming",
      lessonsCompleted: 6,
      totalLessons: 20,
    },
    {
      id: 3,
      title: "Advanced Data Structures",
      description:
        "Master complex data structures and algorithms to ace your technical interviews.",
      progress: 0,
      author: "Dr. Emily Rodriguez",
      lastAccessed: "Not started",
      duration: "6 weeks",
      difficulty: "Advanced",
      rating: 4.8,
      students: 892,
      thumbnail:
        "https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
      category: "Computer Science",
      lessonsCompleted: 0,
      totalLessons: 15,
    },
  ]);

  const AddToCart = (e, course) => {
    e.preventDefault();
    setCart([...cart, course]);
    localStorage.setItem("cartItems", JSON.stringify([...cart, course]));
  };

  const renderRatingStars = (rating) => {
    return (
      <div className="d-flex align-items-center">
        <div className="text-warning me-1">
          {[...Array(5)].map((_, i) => (
            <i
              key={i}
              className={`fa ${
                i < Math.floor(rating)
                  ? "fa-star"
                  : i < rating
                  ? "fa-star-half-o"
                  : "fa-star-o"
              }`}
            ></i>
          ))}
        </div>
        <small className="text-muted ms-1">{rating.toFixed(1)}</small>
      </div>
    );
  };

  const filteredCourses = myCourses.filter((course) => {
    if (activeTab === "all") return true;
    if (activeTab === "in-progress")
      return course.progress > 0 && course.progress < 100;
    if (activeTab === "completed") return course.progress === 100;
    if (activeTab === "new") return course.progress === 0;
    return true;
  });

  return (
    <div className="my-courses-container bg-light py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12">
            <h1 className="display-5 fw-bold mb-3">My Learning Dashboard</h1>
            <p className="lead text-muted">
              Track your progress and continue your learning journey
            </p>

            <ul className="nav nav-tabs mt-4">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "all" ? "active" : ""}`}
                  onClick={() => setActiveTab("all")}
                >
                  All Courses
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "in-progress" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("in-progress")}
                >
                  In Progress
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "completed" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("completed")}
                >
                  Completed
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "new" ? "active" : ""}`}
                  onClick={() => setActiveTab("new")}
                >
                  New
                </button>
              </li>
            </ul>
          </div>
        </div>

        {filteredCourses.length === 0 ? (
          <div className="text-center py-5">
            <div className="mb-4">
              <i className="fa fa-book-open fa-4x text-muted opacity-25"></i>
            </div>
            <h4 className="fw-bold mb-3">No courses found</h4>
            <p className="text-muted mb-4">
              You don't have any courses in this category yet.
            </p>
            <Link
              to="/courses"
              className="btn btn-primary px-4 py-2 rounded-pill"
            >
              Browse Available Courses
            </Link>
          </div>
        ) : (
          <div className="row g-4">
            {filteredCourses.map((course) => (
              <div className="col-lg-6" key={course.id}>
                <div className="card border-0 shadow-sm h-100 overflow-hidden">
                  <div className="row g-0 h-100">
                    <div className="col-md-4 position-relative">
                      <img
                        src={course.thumbnail}
                        className="h-100 w-100 object-cover"
                        alt={course.title}
                      />
                      <div className="position-absolute bottom-0 start-0 w-100 px-3 py-2 bg-dark bg-opacity-75 text-white">
                        <small className="d-flex align-items-center justify-content-between">
                          <span>
                            <i className="fa fa-play-circle me-1"></i>
                            {course.lessonsCompleted}/{course.totalLessons}{" "}
                            lessons
                          </span>
                          <span>{course.duration}</span>
                        </small>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card-body h-100 d-flex flex-column">
                        <div className="mb-3">
                          <span className="badge bg-primary bg-opacity-10 text-primary mb-2">
                            {course.category}
                          </span>
                          <h3 className="h5 fw-bold mb-2">{course.title}</h3>
                          <p className="text-muted small mb-3">
                            {course.description}
                          </p>

                          <div className="d-flex align-items-center mb-3">
                            <img
                              src={`https://ui-avatars.com/api/?name=${course.author.replace(
                                /\s+/g,
                                "+"
                              )}&background=random`}
                              alt={course.author}
                              className="rounded-circle me-2"
                              width="32"
                              height="32"
                            />
                            <small className="text-muted">
                              {course.author}
                            </small>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            {renderRatingStars(course.rating)}
                            <small className="text-muted">
                              {course.students.toLocaleString()} students
                            </small>
                          </div>
                        </div>

                        <div className="mt-auto">
                          <div
                            className="progress mb-3"
                            style={{ height: "6px" }}
                          >
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{ width: `${course.progress}%` }}
                              aria-valuenow={course.progress}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>

                          <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">
                              <i className="fa fa-clock-o me-1"></i>
                              Last accessed: {course.lastAccessed}
                            </small>

                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-3"
                              onClick={(e) => AddToCart(e, course)}
                            >
                              {course.progress === 0
                                ? "Start Now"
                                : course.progress === 100
                                ? "Review"
                                : "Continue"}
                              <i className="fa fa-arrow-right ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyCourses;
